import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Section } from '@connected/ui/features/layouts';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import z from 'zod';

import { ImpedanceMeasurementsTable } from '@/components/features/final-circuit-protective-device';
import { FooterNavigation } from '@/components/navigation/footer-navigation';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/impedance-measurements/',
)({
    component: RouteComponent,
    validateSearch: z.object({
        page: z.coerce.number().optional().default(1),
    }),
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(
            elektraAppQueryOptions.project.distributionBoardDeviceListOptions({
                electricalProjectVersionId: params.projectVersionId,
            }),
        );
    },
});

function RouteComponent() {
    const { t } = useTranslation('re-inspections');

    const params = Route.useParams();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
        <Section>
            <Section.Header>
                <Section.Header.Title>
                    {t('distribution-box.layout.navigation.impedance-measurements.label')}
                </Section.Header.Title>
            </Section.Header>
            <Section.Content>
                <ImpedanceMeasurementsTable
                    electricalProjectVersionId={params.projectVersionId}
                    electricalProjectDistributionBoardId={params.distributionboardId}
                    currentPage={search.page}
                    onPageChange={(page) => {
                        navigate({ search: prev => ({ ...prev, page }) });
                    }}
                />
            </Section.Content>
            <Section.Footer>
                <FooterNavigation />
            </Section.Footer>
        </Section>
    );
}
